var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.42704 28.6023C2.9122 27.0875 3.18207 25.0186 5.23664 22.3957L5.38362 22.2487C7.48028 20.152 20.5973 8.09188 27.4492 3.35375C28.5532 2.88854 29.5269 3.07975 30.37 3.9229L31.8027 5.35554C31.5541 7.28573 30.6129 9.07238 28.9788 10.7065C20.0943 18.5952 6.35758 30.5329 5.05881 29.2341L4.42704 28.6023Z",
    fill: "#ed3d3f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.47346 2.39568C4.76006 1.10908 6.6366 1.70105 9.10948 4.17394C15.3363 11.1446 27.7724 23.9548 28.8839 25.0663L29.0374 25.2197C30.3155 26.4978 31.2926 27.292 31.9816 27.6071C33.147 29.1952 33.242 30.4813 32.2623 31.461L31.0306 32.6927C30.0164 33.7069 17.2841 21.9909 10.3653 15.0721C3.94192 8.64874 1.32577 4.84152 2.5209 3.64639L3.33525 2.53389L3.47346 2.39568Z",
    fill: "#ed3d3f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseMenu);
export default __webpack_public_path__ + "static/media/close-menu.f617aa142dd631d10909f150deecdd00.svg";
export { ForwardRef as ReactComponent };